// extracted by mini-css-extract-plugin
export default {"reportPageSection":"fuelReportPage_reportPageSection__Irq5l"};